/* =====================================================
   GullyLabs Custom Lightbox — Mobile + Desktop
   Fullscreen white overlay, centered image,
   bottom nav bar with [← 6/9 →]
   Swipe support on mobile
   ===================================================== */

(function () {
    'use strict';

    let currentIndex = 0;
    let images = [];
    let lightboxEl = null;
    let lightboxImg = null;
    let counterEl = null;

    /* Touch / swipe tracking */
    let touchStartX = 0;
    let touchEndX = 0;

    function collectImages() {
        const gallery = document.querySelector('.gully-grid-gallery');
        if (!gallery) return [];

        const imgEls = gallery.querySelectorAll('.product__media-list .product__media-item .product__media img');
        const srcs = [];
        imgEls.forEach(function (img) {
            let src = img.getAttribute('src') || '';
            src = src.replace(/&width=\d+/, '&width=1200');
            if (src && !srcs.includes(src)) {
                srcs.push(src);
            }
        });
        return srcs;
    }

    function createLightbox() {
        lightboxEl = document.createElement('div');
        lightboxEl.id = 'gully-lightbox';
        lightboxEl.innerHTML = `
      <div class="gully-lightbox__close" role="button" tabindex="0" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="gully-lightbox__image-container">
        <img class="gully-lightbox__image" src="" alt="Product image" />
      </div>
      <div class="gully-lightbox__nav">
        <div class="gully-lightbox__nav-btn gully-lightbox__prev" role="button" tabindex="0" aria-label="Previous image">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </div>
        <span class="gully-lightbox__counter">1 / 1</span>
        <div class="gully-lightbox__nav-btn gully-lightbox__next" role="button" tabindex="0" aria-label="Next image">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 6 15 12 9 18"></polyline>
          </svg>
        </div>
      </div>
    `;

        document.body.appendChild(lightboxEl);

        lightboxImg = lightboxEl.querySelector('.gully-lightbox__image');
        counterEl = lightboxEl.querySelector('.gully-lightbox__counter');

        // Event listeners
        lightboxEl.querySelector('.gully-lightbox__close').addEventListener('click', closeLightbox);
        lightboxEl.querySelector('.gully-lightbox__prev').addEventListener('click', prevImage);
        lightboxEl.querySelector('.gully-lightbox__next').addEventListener('click', nextImage);

        // Click overlay background to close
        lightboxEl.addEventListener('click', function (e) {
            if (e.target === lightboxEl || e.target.classList.contains('gully-lightbox__image-container')) {
                closeLightbox();
            }
        });

        // Keyboard nav
        document.addEventListener('keydown', function (e) {
            if (!lightboxEl || lightboxEl.style.display !== 'flex') return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') prevImage();
            if (e.key === 'ArrowRight') nextImage();
        });

        // Touch / swipe support for mobile
        lightboxEl.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        lightboxEl.addEventListener('touchend', function (e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });
    }

    function handleSwipe() {
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) < 50) return; // minimum swipe distance
        if (diff > 0) {
            nextImage();  // swipe left → next
        } else {
            prevImage();  // swipe right → prev
        }
    }

    function openLightbox(index) {
        images = collectImages();
        if (!images.length) return;

        currentIndex = Math.max(0, Math.min(index, images.length - 1));

        if (!lightboxEl) createLightbox();

        updateImage();
        lightboxEl.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        // Prevent the default Dawn modal from opening
        setTimeout(function () {
            var dawnModal = document.querySelector('product-modal');
            if (dawnModal) {
                dawnModal.style.display = 'none';
                dawnModal.removeAttribute('open');
            }
            // Close any open Dawn modal dialogs
            var dialogEls = document.querySelectorAll('.product__modal .modal__dialog');
            dialogEls.forEach(function (d) { d.close && d.close(); });
            // Also hide modal-dialog elements
            document.querySelectorAll('modal-dialog[open]').forEach(function (m) {
                m.removeAttribute('open');
                m.style.display = 'none';
            });
        }, 10);
    }

    function closeLightbox() {
        if (lightboxEl) {
            lightboxEl.style.display = 'none';
        }
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        // Restore Dawn modal if needed
        var dawnModal = document.querySelector('product-modal');
        if (dawnModal) {
            dawnModal.style.display = '';
        }
    }

    function updateImage() {
        if (!lightboxImg || !counterEl) return;
        lightboxImg.src = images[currentIndex];
        counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    function prevImage() {
        if (images.length === 0) return;
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateImage();
    }

    function nextImage() {
        if (images.length === 0) return;
        currentIndex = (currentIndex + 1) % images.length;
        updateImage();
    }

    // Intercept clicks on gallery images (both mobile and desktop)
    function attachClickHandlers() {
        var gallery = document.querySelector('.gully-grid-gallery');
        if (!gallery) return;

        var mediaItems = gallery.querySelectorAll('.product__media-list .product__media-item');
        mediaItems.forEach(function (item, index) {
            // Block the default Dawn modal-opener behavior
            var modalOpener = item.querySelector('modal-opener');
            if (modalOpener) {
                modalOpener.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openLightbox(index);
                }, true);
            }

            // Also handle direct image clicks
            var img = item.querySelector('.product__media img');
            if (img) {
                img.style.cursor = 'zoom-in';
                img.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openLightbox(index);
                });
            }

            // Handle zoom icon button clicks
            var zoomBtn = item.querySelector('.product__media-icon');
            if (zoomBtn) {
                zoomBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openLightbox(index);
                }, true);
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(attachClickHandlers, 500);
        });
    } else {
        setTimeout(attachClickHandlers, 500);
    }
})();
